var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"ma-2 xml-channel-status-card"},[(_vm.xmlChannel.type)?[_c(_vm.types[_vm.xmlChannel.type],_vm._g({tag:"component",attrs:{"xml-channel":_vm.xmlChannel}},_vm.$listeners))]:[_c('xml-channel-status-nyi-card',{attrs:{"xml-channel":_vm.xmlChannel}})]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b0529f8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xmlChannelStatus/XmlChannelStatusCard.vue
// module id = null
// module chunks = 